var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83728 0.384947C10.0542 0.601905 10.0542 0.953664 9.83728 1.17062L5.39284 5.61506C5.17588 5.83202 4.82412 5.83202 4.60716 5.61506L0.162718 1.17062C-0.0542403 0.953663 -0.0542402 0.601905 0.162718 0.384947C0.379677 0.167989 0.731434 0.167989 0.948392 0.384947L5 4.43655L9.05161 0.384947C9.26857 0.167989 9.62032 0.167989 9.83728 0.384947Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f8b93d74ce4e992455fdabacdccb503e.svg";
export { ForwardRef as ReactComponent };